module.exports = __webpack_public_path__ + "static/img/back2.faf5d429.jpg";